import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { auth } from '../../firebaseConfig';
import { GoogleAuthProvider, OAuthProvider, signInWithPopup } from 'firebase/auth';
import { useGlobal } from '../../contexts/GlobalContext';
import { Utils } from '../../common/Utils';
import { useNavigate } from 'react-router-dom';

function NavBar() {
  const { user, logOut, settings, isAdmin } = useGlobal();
  const navigate = useNavigate();
  const handleLogout = async () => {
    try {
      await logOut();
      navigate(Utils.GetUrl("/"));
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  const handleLogin = async () => {

    if (settings.allowMicrosoftLogin) {
      const provider = new OAuthProvider("microsoft.com");

      try {
        await signInWithPopup(auth, provider);
        console.log("Microsoft login successful");
      } catch (err: any) {
        alert("Login Error");
        console.error("Microsoft Login Error:", err);
      }
    }
    else if (settings.allowGoogleLogin) {
      const provider = new GoogleAuthProvider();
      try {
        await signInWithPopup(auth, provider);
        console.log("Google login successful");
      } catch (err: any) {
        alert("Login Error")
        console.error("Google Login Error:", err);
      }
    }

  };

  const singleLogin = settings && !settings.allowEmailLogin && ((settings.allowGoogleLogin && !settings.allowMicrosoftLogin) || (!settings.allowGoogleLogin && settings.allowMicrosoftLogin));

  return (
    <Navbar expand="lg" className="bg-body-tertiary">
      <Container>
        <Navbar.Brand href={Utils.GetUrl("/")}>{settings && settings.siteLogo ? <img src={settings.siteLogo} alt={settings.siteTitle} className='site-logo' /> : settings ? settings.siteTitle : "OrderQ"}</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            {user && isAdmin && <Nav.Link href={Utils.GetUrl("/orders")}>Orders</Nav.Link>}
          </Nav>
          <Nav className="ms-auto">
            {user ? (
              <NavDropdown
                title="User"
                align="end"
              >
                <NavDropdown.Item href={Utils.GetUrl("/UserProfile")}>User Profile</NavDropdown.Item>
                <NavDropdown.Item onClick={handleLogout}>Log Out</NavDropdown.Item>
              </NavDropdown>
            ) : (

              <Nav.Link
                href={singleLogin ? "#" : Utils.GetUrl("/login")}
                className="ms-2"
                onClick={(e) => {
                  if (singleLogin) {
                    e.preventDefault(); // Prevent navigation if Google login is allowed
                    handleLogin(); // Fire the login event
                  }
                }}
              >
                Sign In
              </Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;